(function () {
  function formatCount(n) {
    try {
      return Number(n).toLocaleString('en-US');
    } catch (e) {
      return String(n);
    }
  }

  function applyAggregate(root, detail) {
    if (!root || !detail) return;
    var avg = detail.avg;
    var count = detail.count;
    if (avg == null || !Number.isFinite(Number(avg)) || count == null || !Number.isFinite(Number(count)) || Number(count) <= 0) {
      return;
    }
    var ratingEl = root.querySelector('[data-amc-trust-rating]');
    var countEl = root.querySelector('[data-amc-trust-count]');
    var avgLabel = detail.avgLabel != null ? String(detail.avgLabel) : Number(avg).toFixed(2);
    var countLabel = detail.countLabel != null ? String(detail.countLabel) : formatCount(count);
    if (ratingEl) ratingEl.textContent = avgLabel;
    if (countEl) countEl.textContent = countLabel + ' Reviews';
    root.classList.remove('is-loading');
  }

  function readFromReviewsDom() {
    var summary = document.querySelector('.crt-summary[data-crt-avg][data-crt-count]');
    if (!summary) return null;
    var avg = Number(summary.getAttribute('data-crt-avg'));
    var count = Number(summary.getAttribute('data-crt-count'));
    if (!Number.isFinite(avg) || !Number.isFinite(count) || count <= 0) return null;
    return {
      avg: avg,
      count: count,
      avgLabel: summary.getAttribute('data-crt-avg'),
      countLabel: formatCount(count)
    };
  }

  function init() {
    var bar = document.querySelector('[data-amc-campaign-trust]');
    if (!bar) return;

    document.addEventListener('amc:reviews-aggregate', function (event) {
      applyAggregate(bar, event.detail || {});
    });

    var existing = readFromReviewsDom();
    if (existing) applyAggregate(bar, existing);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
